import { render, staticRenderFns } from "./consultDetail.vue?vue&type=template&id=35b1d0be"
import script from "./consultDetail.vue?vue&type=script&lang=js"
export * from "./consultDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35b1d0be')) {
      api.createRecord('35b1d0be', component.options)
    } else {
      api.reload('35b1d0be', component.options)
    }
    module.hot.accept("./consultDetail.vue?vue&type=template&id=35b1d0be", function () {
      api.rerender('35b1d0be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/consultDetail.vue"
export default component.exports